import { getDeviceId } from '../../utils/deviceId';

// POST + fetch 保留鉴权和设备头；一次请求完成正文流和最终入口建议。
export async function streamCreationIntake(input, { signal, onReplyDelta, timeoutMs = 50000 } = {}) {
  const controller = new AbortController();
  const abort = () => controller.abort();
  signal?.addEventListener('abort', abort, { once: true });
  if (signal?.aborted) abort();
  let timedOut = false;
  const timer = setTimeout(() => { timedOut = true; abort(); }, timeoutMs);
  let reader;
  try {
    const token = localStorage.getItem('token');
    const response = await fetch('/api/creation/intake', {
      method: 'POST', signal: controller.signal,
      headers: { 'Content-Type': 'application/json', Accept: 'text/event-stream', 'X-Xiaoying-Device-ID': getDeviceId(),
        ...(token ? { Authorization: `Bearer ${token}` } : {}) },
      body: JSON.stringify({ ...input, stream: true }),
    });
    if (!response.ok) {
      const data = await response.json().catch(() => ({}));
      if (response.status === 401) localStorage.removeItem('token');
      throw Object.assign(new Error(data.error || '需求助手暂时不可用，请稍后重试。'), { response: { status: response.status, data } });
    }
    // 滚动发布期间兼容旧服务返回 JSON，不额外重发模型请求。
    if (response.headers.get('Content-Type')?.includes('application/json')) return await response.json();
    if (!response.body) throw new Error('无法读取回复，请重试。');
    reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = ''; let replyLength = 0;
    while (true) {
      const { done, value } = await reader.read();
      if (done) throw new Error('回复连接已中断，想法已保留，请重试。');
      buffer += decoder.decode(value, { stream: true });
      if (buffer.length > 65536) throw new Error('回复格式异常，请重试。');
      let boundary;
      while ((boundary = /\r?\n\r?\n/.exec(buffer))) {
        const lines = buffer.slice(0, boundary.index).split(/\r?\n/);
        buffer = buffer.slice(boundary.index + boundary[0].length);
        const type = lines.find(line => line.startsWith('event:'))?.slice(6).trim();
        const payload = lines.filter(line => line.startsWith('data:')).map(line => line.slice(5).trimStart()).join('\n');
        if (!payload) continue;
        const data = JSON.parse(payload);
        if (type === 'error') throw new Error(data.error || '回复暂时中断，请重试。');
        if (type === 'done') return data;
        if (type === 'delta' && typeof data.text === 'string') {
          replyLength += data.text.length;
          if (replyLength > 2000) throw new Error('回复过长，请重试。');
          onReplyDelta?.(data.text);
        }
      }
    }
  } catch (error) {
    if (timedOut) throw new Error('需求整理超时，想法已保留，请重试。');
    throw error;
  } finally {
    clearTimeout(timer);
    signal?.removeEventListener('abort', abort);
    if (reader) { await reader.cancel().catch(() => {}); reader.releaseLock(); }
  }
}
